<template>
  <div class="smart-power">
    <iframe
      :src="link"
      v-if="link"
      frameborder="0"
      allow="fullscreen; autoplay"
      sandbox="allow-scripts allow-same-origin allow-popups allow-forms allow-downloads"
    ></iframe>
  </div>
</template>

<script>
export default {
  // 命名需匹配 main.vue 中 /^cache-.*$/ 的规则，iframe 切走不重新加载
  name: "cache-smartPower",
  data() {
    return {
      // 智慧用电大屏（外部页面，内嵌展示，不新开页签）
      link: "https://qrcode.hangyuegroup.com/layout-design/big-screen-preview?content=eyJpZCI6IjQ5MDgyMTk3Nzc1NTg2NjE1MiIsInRlbmFudElkIjoiMTQxNjQ3NiJ9&token=eyJhbGciOiJIUzI1NiJ9.eyJ0dCI6IjAiLCJ1c2VybmFtZSI6ImFkbWluIiwic2Vzc2lvbklkIjoiMDZiYjkyN2ViZTJmNGIxNzk1NDZjOWQzY2ZjZDA4ZWMiLCJ0aWRzIjoiMCIsImFkbWluIjp0cnVlLCJhY2Nlc3NSZXN0cmljdGVkIjpmYWxzZSwiZXhwIjoxODg4MTA4MzE5fQ.26ij0qCxBY9dp8bhqkDErSLNxgkVH9G5r907Ce2NGV4&tenantId=1416476",
    }
  },
}
</script>

<style lang="less" scoped>
.smart-power {
  width: 100%;
  height: calc(100% - 30px);
  position: relative;

  & > iframe {
    width: 100%;
    height: 100%;
    display: block;
  }
}
</style>
